/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


// Googel places
/* https://github.com/peledies/google-places */



$(".TriggerModal").on("click", function(e){
  e.preventDefault();
  var modal = "#" + $(this).attr('href');
  console.log(modal);
//   $(modal).append('<a href="" rel="modal:close" class="close-modal">Close</a>');
  $(modal).addClass("show");
});  


$(document).on("click", ".close-modal", function(e){
  e.preventDefault();
  console.log("close");
  $(this).parent().removeClass("show");
}); 

if ($("#question")[0]) {
     $(document).ready(function() {
       var n1 = Math.round(Math.random() * 10 + 1);
         var n2 = Math.round(Math.random() * 10 + 1);
       $("#question").val(n1 + " + " + n2);
      $(".Article__CommentForm").submit(function (e) {
              if (eval($("#question").val()) != $("#answer").val()) {
                     $("#answer").css('box-shadow', '0px 0px 7px red');
                    e.preventDefault(); 
              } 
         });
    });
}


if ($("#create_customer")[0]) {
    var dontEnter = false;
    localStorage.fromRegister = 0;
    $('#create_customer').submit(function(event) {
      if(dontEnter == false){
      	event.preventDefault();
        localStorage.fromRegister = 1;
        dontEnter = true;
        $('#create_customer').submit();
      }
    }); 
}

// toggle show/hide for tooltips

$(".tooltip").on("click", function(){
  $( this ).toggleClass("active");
});


if ($(".slider-cta")[0]) {
  $('.slider-cta').flickity({
    // options
    "imagesLoaded": true,
    "percentPosition": false,
    "wrapAround": true,
    "autoPlay": 5000
  });
  
}

